import { Button, Checkbox, DialogContentText, ListItem, Paper, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';
import { createCategory } from '../../../api/api';
import { Category } from '../../../interfaces/tell_me/category.types';
import { getDataSetToRedux } from '../../../utility/getAffirmationAndCategory';

export default function AddCategoryComponent() {
    const dispatch = useDispatch();
    const [categoryId, setCategoryId] = useState(uuidv4());
    const [categoryIndex, setCategoryIndex] = useState(0);
    const [categoryIsActive, setCategoryIsActive] = useState(false);
    const [categoryIsPremium, setCategoryIsPremium] = useState(false);
    const [categoryName, setCategoryName] = useState('');
    const [categoryImage, setCategoryImage] = useState('');

    const handleSave = async () => {
        console.log("SAVE CATEGORY")
        const category: Category = {
            affirmations: [],
            id: categoryId,
            image: categoryImage,
            index: categoryIndex,
            isActive: categoryIsActive,
            isPremium: categoryIsPremium,
            name: categoryName,
        }
        const response = await createCategory(category);
        await getDataSetToRedux(dispatch);

        if (response.success) {
            handleClear();
            alert("Success");
        } else {
            console.log(response.message);
            alert("Error")
        }
    }
    const handleClear = () => {
        setCategoryIsActive(false);
        setCategoryIsPremium(false);
        setCategoryIndex(0);
        setCategoryImage('');
        setCategoryName('');
        setCategoryId(uuidv4());
    }

    return (

        <Paper style={{ minWidth: 800, padding: 25, margin: 25, }}>
            <h2> Add a Category </h2>
            <TextField
                autoFocus
                margin="dense"
                label="id"
                type="email"
                fullWidth
                value={categoryId}
            />
            <TextField
                autoFocus
                margin="dense"
                label="name"
                type="email"
                fullWidth
                value={categoryName}
                onChange={(val) => setCategoryName(val.target.value)}
            />
            <TextField
                autoFocus
                margin="dense"
                label="image"
                type="email"
                fullWidth
                value={categoryImage}
                onChange={(val) => setCategoryImage(val.target.value)}
            />
            <TextField
                autoFocus
                margin="dense"
                label="index"
                type="number"
                fullWidth
                value={categoryIndex.toString()}
                onChange={(val) => {
                    try {
                        setCategoryIndex(Number.parseInt(val.target.value))
                    } catch (error) {
                        console.log(error);
                    }
                }}
            />

            <ListItem>
                <Checkbox
                    checked={categoryIsPremium}
                    onChange={(val, checked) => setCategoryIsPremium(checked)}
                />
                is Premium: {`${categoryIsPremium}`}
            </ListItem>

            <ListItem>
                <Checkbox
                    checked={categoryIsActive}
                    onChange={(val, checked) => setCategoryIsActive(checked)}
                />
                is Active: {`${categoryIsActive}`}
            </ListItem>
            <Button onClick={handleClear} color="primary">
                Clear
            </Button>

            <Button onClick={handleSave} color="primary">
                Save
            </Button>

        </Paper>
    );
}